import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataProvider } from '@mysrc/app/Providers/DataProvider';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { ColDef } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CommonService } from '../../services/commonservice';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';


@Component({
  selector: 'app-page-question-language-settings',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AccordionModule,
    IsgGridComponent,
    CommonModule
  ],
  templateUrl: './page-question-language-settings.component.html',
  styleUrl: './page-question-language-settings.component.scss',
  providers: [CommonService, DataProvider],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PageQuestionLanguageSettingsComponent extends BaseHttpReqRespService implements OnInit {
  public mappingId!: number;
  public folderId!: number;
  public questionId!: number;
  public optionId!: number;
  public optionLanguageId!: number;
  public columnItemId!: number;
  public columnItemLanguageId!: number;
  public folderName!: string;
  questionLanguageForm!: FormGroup;
  public questionLanguageId: number = 0;
  public languageList: language[] = [];
  public saveLanguageSettingsList: questionOptionsLanguageSetting[] = [];
  public questionOptionsList!: any[];
  public columnHeaderList!: any[];
  public columnItemList!: any[];
  public rowItemList!: any[];
  public question!: Question;
  public showOptionConfiguration: boolean = false;
  public questionOptionsLanguageMappedList: questionOptionsLanguageMappedDetail[] = [];
  public deleteMappingId!: number;
  public editMappingId!: number;
  public successOrFailureMessage: string = '';
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;

  @ViewChild('deleteModelConfirmation') deleteModelConfirmationTemplate!: TemplateRef<any>;

  languageGridConfig: Partial<IsgGridConfig> = {
    height: '400px',
    pagination: false,
    rowSelection: 'multiple',
  };

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private route: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private dataProvider: DataProvider,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private commonService: CommonService,
    private modalService: NgbModal,
    public http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
  }

  ngOnInit() {
    this.showOptionConfiguration = false;
    this.optionId = 0;
    this.optionLanguageId = 0;
    this.route.queryParams.subscribe(params => {
      this.questionId = params['questionId'];
    });
    this.questionLanguageForm = this.formBuilder.group({
      mappingId: 0,
      questionId: 0,
      entityTypeId: 0,
      entityId: 0,
      entityTypeText: '',
      languageText: '',
      languageId: 0,
      description: new FormControl(''),
      questionLanguageId: new FormControl(''),
      questionLanguageText: new FormControl(''),
      optionId: new FormControl(''),
      optionLanguageId: new FormControl(''),
      optionLanguageText: new FormControl(''),
      columnHeaderId: new FormControl(''),
      columnHeaderLanguageId: new FormControl(''),
      columnHeaderLanguageText: new FormControl(''),
      columnItemId: new FormControl(''),
      columnItemLanguageId: new FormControl(''),
      columnItemLanguageText: new FormControl(''),
      rowItemId: new FormControl(''),
      rowItemLanguageId: new FormControl(''),
      rowItemLanguageText: new FormControl(''),
      defaultValueId: new FormControl(''),
      defaultValueLanguageId: new FormControl(''),
      defaultValueLanguageText: new FormControl('')
    });


    this.getLanguageList();
    this.getQuestionOptionsList();
    this.getQuestionOptionsLanguageMappedList();
  }

  checkString() {
    var string = this.questionLanguageForm.value.questionLanguageText.trim();
  }

  getQuestionOptionsList() {
    this.http.post<Meta>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.PREVIEW, '', {
      params: { 'questionId': this.questionId.toString() }
    }).toPromise().then(data => {
      // this.questionPreviewData = data;
      this.question = data.metaBody.sections[0].questions[0];

      var question = this.question.type;

      if (this.question.multipleResponse !== null && this.question.multipleResponse.length > 0) {
        this.questionOptionsList = this.question.multipleResponse;
        this.showOptionConfiguration = true;
      }

      if (this.question.multipleChoice !== null && this.question.multipleChoice.length > 0) {
        this.questionOptionsList = this.question.multipleChoice;
        this.showOptionConfiguration = true;
      }

      if (this.question.rankingSort !== null && this.question.rankingSort.length > 0) {
        this.questionOptionsList = this.question.rankingSort;
        this.showOptionConfiguration = true;
      }

      if (this.question.pickList !== null && this.question.pickList.length > 0) {
        this.questionOptionsList = this.question.pickList;
        var picklistoptions = this.question.pickList;
        this.questionOptionsList = picklistoptions;
        this.showOptionConfiguration = true;
      }

      if (this.question.slider !== null && this.question.slider.length > 0) {
        this.questionOptionsList = this.question.slider;
        this.showOptionConfiguration = true;
      }


      if (this.question.matrix !== null && this.question.matrix.columns.length > 0) {
        this.columnHeaderList = this.question.matrix.columns;
      }

      if (this.question.matrix !== null && this.question.matrix.columnFields.length > 0) {
        this.columnItemList = this.question.matrix.columnFields;
      }

      if (this.question.matrix !== null && this.question.matrix.rowdataFields.length > 0) {
        this.rowItemList = this.question.matrix.rowdataFields;
      }
    });
    //this.commonService.httpGet("", this.baseUrl + '/' + this._getLanguageUrl).toPromise().then(result => {
    //  this.languageList = result;
    //}, error => console.error(error));

    let parameter = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.baseUrl + '/' + this.QUESTION_ENDPOINT.OPTION_MAPPED_LIST + parameter).toPromise().then(result => {
      this.questionOptionsLanguageMappedList = result;

    }, error => console.error(error));


  }

  getLanguageList() {
    this.commonService.httpGet("", this.baseUrl + '/' + this.QUESTION_ENDPOINT.LANGUAGE_LIST).toPromise().then(result => {
      this.languageList = result;
    }, error => console.error(error));
  }

  getQuestionOptionsLanguageMappedList() {
    let parameter = "?questionId=" + this.questionId;
    this.commonService.httpGet("", this.baseUrl + '/' + this.QUESTION_ENDPOINT.OPTION_MAPPED_LIST + parameter).toPromise().then(result => {
      this.questionOptionsLanguageMappedList = result;

    }, error => console.error(error));
  }

  backUrl() {
    //if (this.folderId == -1)
    //  this._router.navigate(['/question']);
    //else
    //  this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
    this._router.navigate(['/question']);
  }


  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

  saveQuestionLanguage() {
    this.questionLanguageForm.patchValue({
      mappingId: this.mappingId,
      questionId: this.questionId,
      entityId: this.questionId,
      entityTypeText: 'Question Text',
      languageId: this.questionLanguageForm.value.questionLanguageId,
      languageText: this.questionLanguageForm.value.questionLanguageText
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {

      this.questionLanguageForm.controls.questionLanguageId.setValue("");
      this.questionLanguageForm.controls.questionLanguageText.setValue("");
      this.getQuestionOptionsLanguageMappedList();
      this.mappingId = 0;
    }, error => console.error(error));
  }

  resetQuestionLanguage() {
    this.questionLanguageForm.controls.questionLanguageId.setValue("");
    this.questionLanguageForm.controls.questionLanguageText.setValue("");
  }

  saveOptionLanguage() {
    this.questionLanguageForm.patchValue({
      mappingId: this.mappingId,
      questionId: this.questionId,
      entityId: this.questionLanguageForm.value.optionId,
      entityTypeText: 'Option Text',
      languageId: this.questionLanguageForm.value.optionLanguageId,
      languageText: this.questionLanguageForm.value.optionLanguageText
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {
      this.questionLanguageForm.controls.optionId.setValue("");
      this.questionLanguageForm.controls.optionLanguageId.setValue("");
      this.questionLanguageForm.controls.optionLanguageText.setValue("");
      this.mappingId = 0;
      this.getQuestionOptionsLanguageMappedList();
    }, error => console.error(error));
  }


  resetOptionLanguage() {
    this.questionLanguageForm.controls.optionId.setValue("");
    this.questionLanguageForm.controls.optionLanguageId.setValue("");
    this.questionLanguageForm.controls.optionLanguageText.setValue("");
  }

  saveColumnHeaderLanguage() {
    this.questionLanguageForm.patchValue({
      questionId: this.questionId,
      entityId: this.questionLanguageForm.value.columnHeaderId,
      entityTypeText: 'Column Header Text',
      languageId: this.questionLanguageForm.value.columnHeaderLanguageId,
      languageText: this.questionLanguageForm.value.columnHeaderLanguageText
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {
      this.questionLanguageForm.value.columnHeaderId = 0;
      this.questionLanguageForm.value.columnHeaderLanguageId = 0;
      this.questionLanguageForm.value.columnHeaderLanguageText = "";
      this.getQuestionOptionsLanguageMappedList();
    }, error => console.error(error));
  }



  resetColumnHeaderLanguage() {
    this.questionLanguageForm.value.columnHeaderId = 0;
    this.questionLanguageForm.value.columnHeaderLanguageId = 0;
    this.questionLanguageForm.value.columnHeaderLanguageText = "";
  }

  saveColumnItemLanguage() {
    this.questionLanguageForm.patchValue({
      mappingId: this.mappingId,
      questionId: this.questionId,
      entityId: this.questionLanguageForm.value.columnItemId,
      entityTypeText: 'Column Item Text',
      languageId: this.questionLanguageForm.value.columnItemLanguageId,
      languageText: this.questionLanguageForm.value.columnItemLanguageText
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {
      this.questionLanguageForm.controls.columnItemId.setValue("");
      this.questionLanguageForm.controls.columnItemLanguageId.setValue("");
      this.questionLanguageForm.controls.columnItemLanguageText.setValue("");
      this.mappingId = 0;
      this.getQuestionOptionsLanguageMappedList();
    });
  }

  resetColumnItemLanguage() {
    this.questionLanguageForm.controls.columnItemId.setValue("");
    this.questionLanguageForm.controls.columnItemLanguageId.setValue("");
    this.questionLanguageForm.controls.columnItemLanguageText.setValue("");
  }

  saveRowItemLanguage() {
    this.questionLanguageForm.patchValue({
      mappingId: this.mappingId,
      questionId: this.questionId,
      entityId: this.questionLanguageForm.value.rowItemId,
      entityTypeText: 'Row Item Text',
      languageId: this.questionLanguageForm.value.rowItemLanguageId,
      languageText: this.questionLanguageForm.value.rowItemLanguageText
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    };

    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {
      this.questionLanguageForm.controls.rowItemId.setValue("");
      this.questionLanguageForm.controls.rowItemLanguageId.setValue("");
      this.questionLanguageForm.controls.rowItemLanguageText.setValue("");
      this.mappingId = 0;
      this.getQuestionOptionsLanguageMappedList();
    });
  }


  resetRowItemLanguage() {
    this.questionLanguageForm.controls.rowItemId.setValue("");
    this.questionLanguageForm.controls.rowItemLanguageId.setValue("");
    this.questionLanguageForm.controls.rowItemLanguageText.setValue("");
  }


  saveDefaultValueLanguage() {
    this.questionLanguageForm.patchValue({
      questionId: this.questionId,
      entityId: this.questionLanguageForm.value.entityId,
      entityTypeText: 'Default Value Text',
      languageId: this.questionLanguageForm.value.defaultValueLanguageId,
      languageText: this.questionLanguageForm.value.defaultValueLanguageText
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    };

    this.http.post<any>(this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS, this.questionLanguageForm.value, httpOptions).subscribe(result => {
      this.questionLanguageForm.value.defaultValueId = 0;
      this.questionLanguageForm.value.defaultValueLanguageId = 0;
      this.questionLanguageForm.value.defaultValueLanguageText = "";
      this.getQuestionOptionsLanguageMappedList();
    });
  }

  resetDefaultValueLanguage() {
    this.questionLanguageForm.value.defaultValueId = 0;
    this.questionLanguageForm.value.defaultValueLanguageId = 0;
    this.questionLanguageForm.value.defaultValueLanguageText = "";
  }

  columnDefs: ColDef[] = [
    { headerName: 'Mapping Id', field: 'mappingId', hide: true },
    { headerName: 'Question Description', field: 'questionDescription', cellStyle: { 'white-space': 'normal' }, filter: true, sortable: true, tooltipField: 'questionDescription', width: 300 },
    { headerName: 'Entity Type Name', field: 'entityTypeName', width: 250, filter: true, sortable: true, tooltipField: 'entityTypeName', resizable: true },
    { headerName: 'Entity Value', field: 'entityValue', filter: true, sortable: true, tooltipField: 'entityValue', width: 300, resizable: true },
    { headerName: 'Language Text', field: 'languageText', filter: true, sortable: true, tooltipField: 'languageText', width: 300, resizable: true },
    { headerName: 'Language Name', field: 'languageName', filter: true, sortable: true, tooltipField: 'languageName', width: 300, resizable: true },
    { headerName: 'Edit', cellRenderer: this.editImageRenderer.bind(this), width: 100, resizable: true },
    { headerName: 'Delete', cellRenderer: this.deleteImageRenderer.bind(this), width: 100, resizable: true }

  ];

  deleteImageRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {
      this.deleteMappingId = params.data.mappingid;
      this.openDeleteConfirmationModal();
    });
    return element;
  }

  openDeleteConfirmationModal() {
    if (this.deleteModelConfirmationTemplate) {
      this.modalService.open(this.deleteModelConfirmationTemplate);
    }
  }

  editImageRenderer(params: any) {
    const editAnchor = this.renderer.createElement('a');
    const editIcon = this.renderer.createElement('i');
    editIcon.setAttribute('class', 'fa fa-edit anchor-cursor');
    editIcon.setAttribute('title', 'Edit Language Settings');
    this.renderer.appendChild(editAnchor, editIcon);


    this.renderer.listen(editAnchor, 'click', () => {
      this.editMappingId = params.data.mappingid;
      this.enableEditFields(this.editMappingId);
    })
    return editAnchor;
  }

  enableEditFields(mappingId: any) {
    this.mappingId = mappingId;
    let mappedDetail: questionOptionsLanguageMappedDetail[];
    mappedDetail = this.questionOptionsLanguageMappedList.filter(x => x.mappingid == mappingId);

    var questionLanguageId: number = 0;
    var questionLanguageText: string = '';
    var optionId: number = 0;
    var optionLanguageId: number = 0;
    var optionLanguageText: string = '';
    var columnItemId: number = 0;
    var columnItemLanguageId: number = 0;
    var columnItemLanguageText: string = '';
    var rowItemId: number = 0;
    var rowItemLanguageId: number = 0;
    var rowItemLanguageText: string = '';

    if (mappedDetail[0].entityTypeName.toLowerCase() == 'question text') {
      var questionLanguage = this.languageList.filter(x => x.languageName === mappedDetail[0].languageName);
      questionLanguageId = questionLanguage[0].languageId;
      questionLanguageText = mappedDetail[0].languageText;
      this.questionLanguageForm.controls.questionLanguageId.setValue(questionLanguageId);
      this.questionLanguageForm.controls.questionLanguageText.setValue(questionLanguageText);
      this.questionLanguageForm.patchValue({
        mappingId: this.editMappingId
      });
    }

    if (mappedDetail[0].entityTypeName.toLowerCase() == 'option text') {
      var option: any[];
      if (this.question.type.toLowerCase() === 'picklist') {
        option = this.questionOptionsList.filter(x => x.text == mappedDetail[0].entityValue);
        optionId = parseInt(option[0].value);
        this.optionId = parseInt(option[0].value);
      }
      else {
        option = this.questionOptionsList.filter(x => x.name == mappedDetail[0].entityValue);
        optionId = option[0].optionId;
      }

      var optionLanguage = this.languageList.filter(
        x => x.languageName === mappedDetail[0].languageName
      );
      optionLanguageId = optionLanguage[0].languageId;
      optionLanguageText = mappedDetail[0].languageText;
      this.questionLanguageForm.controls.optionId.setValue(optionId);
      this.questionLanguageForm.controls.optionLanguageId.setValue(optionLanguageId);
      this.questionLanguageForm.controls.optionLanguageText.setValue(optionLanguageText);
      this.questionLanguageForm.value.mappingId = mappingId;
    }

    if (mappedDetail[0].entityTypeName.toLowerCase() == 'column item text') {
      var columnItem = this.columnItemList.filter(x => x.columnHeaderText == mappedDetail[0].entityValue);
      columnItemId = columnItem[0].columnItemId;
      var columnItemLanguage = this.languageList.filter(x => x.languageName === mappedDetail[0].languageName);
      columnItemLanguageId = columnItemLanguage[0].languageId;
      columnItemLanguageText = mappedDetail[0].languageText;
      this.questionLanguageForm.controls.columnItemId.setValue(columnItemId);
      this.questionLanguageForm.controls.columnItemLanguageId.setValue(columnItemLanguageId);
      this.questionLanguageForm.controls.columnItemLanguageText.setValue(columnItemLanguageText);
      this.questionLanguageForm.value.mappingId = mappingId;
    }

    if (mappedDetail[0].entityTypeName.toLowerCase() == 'row item text') {
      var rowItem = this.rowItemList.filter(x => x.rowText == mappedDetail[0].entityValue);
      rowItemId = rowItem[0].rowItemId;
      var rowItemLanguage = this.languageList.filter(x => x.languageName === mappedDetail[0].languageName);
      rowItemLanguageId = rowItemLanguage[0].languageId;
      rowItemLanguageText = mappedDetail[0].languageText;
      this.questionLanguageForm.controls.rowItemId.setValue(rowItemId);
      this.questionLanguageForm.controls.rowItemLanguageId.setValue(rowItemLanguageId);
      this.questionLanguageForm.controls.rowItemLanguageText.setValue(rowItemLanguageText);
      this.questionLanguageForm.value.mappingId = mappingId;
    }
  }

  onRowChecked(params: any) {
  }

  deleteMapping() {
    let parameter = "?questionId=" + this.questionId + "&mappingId=" + this.deleteMappingId;
    this.commonService.httpGet("", this.baseUrl + '/' + this.QUESTION_ENDPOINT.SAVE_OPTION_LANGUAGE_SETTINGS + parameter).subscribe(result => {
      this.questionOptionsLanguageMappedList = result;
      this.messageTimeout();
      this.successOrFailureMessage = "Deleted data successfully.";
    }, error => {
      this.successOrFailureMessage = "Error occurred while trying to delete the specified mapping.Please try again..";
    });
  }

  messageTimeout() {
    window.setTimeout(() => {
      this.successOrFailureMessage = '';
    }, 3200);
  }
}


export interface language {
  languageId: number;
  languageName: string;
}

export interface questionOptionsLanguageSetting {
  mappingId: number;
  questionId: number;
  entityTypeId: number;
  entityId: number;
  languageText: string;
  languageId: number
}

export interface Question {
  qid: number;
  qrid: number;
  text: string;
  value: string;
  isAnswered: boolean;
  order: number;
  type: string;
  matrix: Matrix;
  multipleResponse: Option[];
  multipleChoice: Option[];
  rankingSort: RankingSortOption[];
  pickList: PickListItem[];
  isRequired: boolean;
  displayNumberText: string;
  slider: GradingRangeDetails[];
  defaultValue: number;
  isPartialAnswer: boolean;
  isShow: boolean;
  width: string;
  constantSum: ConstantSum;
}

export interface Matrix {
  rowdataFields: RowdataField[];
  columnFields: ColumnField[];
  columns: Column[];
  hideRowHeader: boolean;
  headerInnerHTML: string;
  isEveryRowMandatory: boolean;
  description: string;
  headerDescription: string;
  headerValue: string;
}

export interface Option {
  optionId: number;
  name: string;
  value: string;
  selected: boolean;
  order: number;
  evaluateAndExit: boolean;
  isTextBoxRequired: boolean;
  additionalTextBoxValue: string;
  showAdditionalTextBox: boolean;
  displayOrder: string;
  hoverText: string;
  isShowHoverText: boolean;
}

export interface RankingSortOption {
  optionId: number;
  questionId: number;
  sectionId: number;
  name: string;
  value: string;
  selected: boolean;
  order: number;
  displayOrder: string;
}

export interface PickListItem {
  text: string;
  value: string;
  displayorder: number;
  selected: boolean;
  display: boolean;
}

export interface GradingRangeDetails {
  rangeId: number;
  min: number;
  max: number;
  rangeDescription: string;

}

export interface ConstantSum {
  rowdataFields: RowdataField[];
  columnFields: ColumnField[];
  columns: Column[];
  hideRowHeader: boolean;
  headerInnerHTML: string;
  isEveryRowMandatory: boolean;
}

export interface RowdataField {
  rowItemId: number
  rowText: string;
  cellReferences: CellReference[];
}

export interface ColumnField {
  columnItemId: number;
  columnHeaderText: string;
  columnType: string;
  controlType: string;
  defaultValue: any;
  dataSource: any[];
  isRequired: boolean;
  isEnabled: boolean;
  order: number;
  min: number | null;
  max: number | null;
  width: number | null;
}

export interface CellReference {
  cellAddress: number[];
  value: any;
  smqid: number;
}

export interface Column {
  name: string;
  colspan: number;
  childColumns: string[];
}

export interface Meta {
  responseId: number;
  serviceLineId: number;
  companyId: number;
  userId: number;
  metaFields: string[];
  surveytitle: string;
  surveydescription: string;
  surveytype: string;
  isautosave: boolean;
  isprogressbar: boolean;
  perpage: number;
  surveyId: number;
  isSubmitted: boolean;
  metaBody: MetaBody;
  fromModule: string;
  isOverDue: boolean;
  isforcefullysubmitted: boolean;
  surveyName: string;
  showQuestionNumber: boolean;
}
export interface MetaForm {
  responseId: number;
  serviceLineId: number;
  companyId: number;
  userId: number;
  surveytitle: string;
  surveydescription: string;
  surveytype: string;
  isautosave: boolean;
  isprogressbar: boolean;
  perpage: number;
  surveyId: number;
  isPreview: boolean;
  sections: Section[];
  isforcefullysubmitted: boolean;

}

export interface Section {
  id: number;
  order: number;
  name: string;
  description: string;
  type: string;
  isConfirmationRequires: boolean;
  isConfirmed: boolean;
  acceptedText: string;
  notAcceptedText: string;
  questions: Question[];
  qSOrder: number;
  isShowSection: boolean;
  isHide: boolean;

}
export interface MetaBody {
  sections: Section[];
  uploadedDocumentsList: uploadedDocuments[];
}

export interface uploadedDocuments {
  documentId: number;
  documentName: string;
  filePath: string;
  fileName: string;
  serviceLineId: number;
  companyId: number;
  userId: number;
  surveyId: number;
}

export interface questionOptions {
  questionId: number;
  questionOptionId: number;
  description: string;
  displayOrder: number;
  weightage: string;
  optionShortName: string;
  hoverText: string;
}

export interface questionOptionsLanguageMappedDetail {
  mappingid: number;
  questionDescription: string;
  entityTypeName: string;
  entityValue: string;
  languageText: string;
  languageName: string;
}

